import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Link,
  Button,
  Chip,
  alpha,
  useTheme,
  CircularProgress
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Computer as ComputerIcon,
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import HostDetailsDashboard from '../../components/EsdlMonitoring/HostDetailsDashboard';

const HostDetails = () => {
  const { hostname } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  
  const handleRefresh = () => {
    setRefreshKey(prevKey => prevKey + 1);
  };
  
  const handleBack = () => {
    navigate('/esdl-monitoring');
  };
  
  return (
    <Container maxWidth="xl" sx={{ pb: 4 }}>
      <Box mb={4}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 3,
          flexWrap: { xs: 'wrap', md: 'nowrap' },
          gap: 2
        }}>
          <Box>
            <Breadcrumbs aria-label="breadcrumb">
              <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
                <DashboardIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
                Dashboard
              </Link>
              <Link component={RouterLink} to="/esdl-monitoring" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
                ESDL Monitoring
              </Link>
              <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
                <ComputerIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
                {hostname}
              </Typography>
            </Breadcrumbs>
            
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <Typography 
                variant="h4" 
                component="h1" 
                fontWeight="bold" 
                sx={{ 
                  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textFillColor: 'transparent'
                }}
              >
                Host Details
              </Typography>
              
              <Chip
                label={hostname}
                color="primary"
                size="medium"
                sx={{ ml: 2, px: 1, fontWeight: 'medium' }}
              />
            </Box>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
              sx={{ 
                textTransform: 'none',
                borderRadius: 2,
                py: 1
              }}
            >
              Back
            </Button>
            
            <Button
              variant="contained"
              disableElevation
              startIcon={<RefreshIcon />}
              onClick={handleRefresh}
              sx={{ 
                textTransform: 'none',
                borderRadius: 2,
                py: 1
              }}
            >
              Refresh
            </Button>
          </Box>
        </Box>
        
        <HostDetailsDashboard 
          key={refreshKey}
          hostname={hostname} 
        />
      </Box>
    </Container>
  );
};

export default HostDetails; 